<section>
    <div class="container">
        <div class="row" class="font-weight-bold text-primary title-style">
            Client Details
        </div>
        <div class="addnew" fxLayout="row" fxLayoutAlign="center center" style="margin-bottom:  15px;">
            <a class="link" routerLink="../clients">
                << Back to Client list</a>
        </div>

        <form style="margin: 13px;" #f="ngForm">

            <div class="row" class="font-weight-bold text-primary linde-divider">
                CLIENT INFORMATION
            </div>

            <div class="form-row headrgap">
                <div class="form-group col-md-8">
                    <label>Company / Client Name</label>
                    <input type="text" class="form-control" name="companyName" [(ngModel)]="company.companyName" placeholder="Enter" />
                </div>
            </div>

           
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label>Email</label>
                    <input type="text" class="form-control" name="email" [(ngModel)]="company.emailContact.email" 
                    placeholder="Enter" />
                </div>
                <div class="form-group col-md-4">
                    <label>Daytime Telephone Number</label>
                    <div class="row">
                        <select class="form-control col-md-4 phoneCodeSelect" name="phoneCode"
                            [(ngModel)]="company.phoneContact.countryCode">
                            <option *ngFor="let code of listCountry" [value]="code.countryCode">+{{code.phoneCode}} -
                                {{code.countryName}}</option>
                        </select>
                        <input class="form-control col-md-8 phoneInput" name="phoneNo"
                            [(ngModel)]="company.phoneContact.phoneNo" type="text" form placeholder="Home" required />
                    </div>
                </div>
            </div>

            <div class="form-row headrgap">
                <div class="form-group col-md-12">
                    <label>Address Line1</label>
                    <input class="form-control" name="addressLine" [(ngModel)]="company.address[0].addressLine1" type="text"
                        placeholder="Enter" required />
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label>Address Line2</label>
                    <input class="form-control" name="addressLines" [(ngModel)]="company.address[0].addressLine2"
                        type="text" placeholder="Enter" />
                </div>
            </div>

            <div class="row">
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <mat-form-field>
                            <mat-label>Country</mat-label>
                            <mat-select name="addCountry" [(ngModel)]="company.address[0].countryCode"
                                 required>
                                <mat-option *ngFor="let item of listCountry" [value]="item.countryCode">
                                    {{item.countryName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-md-3">
                        <label>State</label>
                        <input class="form-control"name="stateProvinceName"
                        [(ngModel)]="company.address[0].stateProvinceName" type="text" placeholder="Country" />
                    </div>
                    <div class="form-group col-md-3">
                        <label class="col-md-12">City</label>
                        <input class="form-control" name="city" [(ngModel)]="company.address[0].city"
                        type="text" placeholder="City" />
                    </div>
                    <div class="form-group col-md-3">
                        <label>Zip Code</label>
                        <input class="form-control" name="postCode" [(ngModel)]="company.address[0].postCode"
                        type="text" placeholder="Zip Code" />
                    </div>
                </div>
            </div> 
           
        </form>
    </div>
</section>